<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="noteListModal.show" @show="onShow" :content-in-form="false" @hidden="onHidden"
                   :title="$t('Notes')" :show-confirmation="showConfirmation" :hide-footer="hideFooter"
                   :ok-title="$t('Submit')" :is-loading="loading" :data="model" scrollable body-class="pt-0">

      <div v-if="object" style="max-height: 20em" class="overflow-auto mb-3 pr-2">
        <NotesList :object-name="objectName" :plural-object-name="pluralObjectName"
                   :change-permission="changePermission" :selected-uuid="model.uuid"
                   :object-uuid="object.uuid" :is-modals-component="true" @editClick="onEditClick"
                   @updateTotalNotes="onUpdateTotalNotes"></NotesList>
      </div>

      <div v-if="$hasPermission(changePermission)">
        <div class="d-flex align-items-center">
          <h5 class="d-inline-block">
            {{ model && model.uuid ? $t(`Editing Existing Note`) : $t(`Creating New Note`) }}
          </h5>
          <b-button class="ml-auto p-0" variant="link" @click="onCreateNewClick">
            {{ $t('Create New Note') }}
          </b-button>
        </div>
        <div class="row p-0">
          <div class="col-md-12">
            <input-widget type="ckeditor" :label="false" :model="model" attribute="description" @input="onCkeditorInput"/>
          </div>
        </div>
      </div>
      <template v-slot:modal-footer v-if="!hideFooter">
        <cancel-button @click="onCancel">
          {{ $t('Cancel') }}
        </cancel-button>
        <submit-button @click="handleSubmit(onSubmit)" :disabled="loading" :show-loader="loading">
          {{ $t('Submit') }}
        </submit-button>
      </template>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import NoteListModel from "@/modules/notes/NoteList.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import CancelButton from "@/core/components/common/CancelButton";
  import SubmitButton from "@/core/components/common/SubmitButton";
  import NotesList from "@/modules/notes/NotesList";

  const {mapState, mapActions} = createNamespacedHelpers('notes');

  export default {
    name: "NoteListModal",
    components: {ArtisioModal, InputWidget, CancelButton, SubmitButton, NotesList},
    data() {
      return {
        showConfirmation: true,
        loading: false,
        model: new NoteListModel(),
      }
    },
    computed: {
      ...mapState({
        noteListModal: state => state.noteListModal,
        objectName: state => state.noteListModal.objectName,
        pluralObjectName: state => state.noteListModal.pluralObjectName,
        changePermission: state => state.noteListModal.changePermission,
        deletePermission: state => state.noteListModal.deletePermission,
        hideFooter: state => state.noteListModal.hideFooter,
        object: state => state.noteListModal.object,
      }),
    },
    methods: {
      ...mapActions(['removeNote', 'hideNoteListModal', 'createNote', 'updateNote']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new NoteListModel();
        this.hideNoteListModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;
        this.model[`${this.objectName}_uuid`] = this.object.uuid;
        if (!this.model.uuid) {
          response = await this.createNote(this.model);
        } else {
          response = await this.updateNote(this.model);
        }
        this.loading = false;
        if (response.success) {
          this.showConfirmation = false;
          this.model = new NoteListModel()
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Note was successfully created'));
            this.$emit('updateTotalNotes')
          } else {
            this.$toast('success', this.$t('Note was successfully updated'));
          }
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onCancel() {
        this.hideNoteListModal()
      },
      onCreateNewClick() {
        this.model = new NoteListModel();
      },
      onCkeditorInput() {
        requestAnimationFrame(() => {
          this.$refs.observer.reset();
        })
      },
      onUpdateTotalNotes() {
        this.$emit('updateTotalNotes')
      },
      onEditClick(note) {
        this.model = new NoteListModel(note)
      },
    },
  }
</script>

<style scoped>
  /deep/ .ck-editor__editable {
    min-height: 150px;
  }
</style>
